import React, { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import i18n from '../../i18n/config';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="p-4 border border-red-300 bg-red-50 rounded-md">
            <h2 className="text-red-800 font-semibold mb-2">
              {i18n.t('error.something_went_wrong')}
            </h2>
            <p className="text-red-600">{this.state.error?.message}</p>
            <button
              className="mt-2 text-blue-600 underline"
              onClick={() => Sentry.showReportDialog()}
            >
              {i18n.t('error.report_feedback')}
            </button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
